"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductRecommendationPriority = void 0;
var ProductRecommendationPriority;
(function (ProductRecommendationPriority) {
    ProductRecommendationPriority[ProductRecommendationPriority["HIGH"] = 0] = "HIGH";
    ProductRecommendationPriority[ProductRecommendationPriority["MEDIUM"] = 1] = "MEDIUM";
    ProductRecommendationPriority[ProductRecommendationPriority["LOW"] = 2] = "LOW";
})(ProductRecommendationPriority = exports.ProductRecommendationPriority || (exports.ProductRecommendationPriority = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdC1yZWNvbW1lbmRhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tZWF0LWNvbmZpZ3VyYXRpb24vdHlwZXMvcHJvZHVjdC1yZWNvbW1lbmRhdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFFSCxJQUFZLDZCQUlYO0FBSkQsV0FBWSw2QkFBNkI7SUFDdkMsaUZBQUksQ0FBQTtJQUNKLHFGQUFNLENBQUE7SUFDTiwrRUFBRyxDQUFBO0FBQ0wsQ0FBQyxFQUpXLDZCQUE2QixHQUE3QixxQ0FBNkIsS0FBN0IscUNBQTZCLFFBSXhDIn0=